import { render, staticRenderFns } from "./my-business-jt808-serv-combine-orders.vue?vue&type=template&id=42110871&scoped=true"
import script from "./my-business-jt808-serv-combine-orders.vue?vue&type=script&lang=js"
export * from "./my-business-jt808-serv-combine-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42110871",
  null
  
)

export default component.exports